/*eslint-disable*/
export default account => {
  let $account = $(account)
  let accountNavBtns = document.querySelectorAll('.account-nav')
  let accountPages = document.querySelectorAll('.account-page')

  const accountNavHandler = () => {

    $(window).bind('hashchange', function () { // detect hash change
      let hash = window.location.hash.slice(1); // hash to string (= "#orders")
      console.log("hash: ", hash)
      accountPages.forEach(page => {
        pageHandler(page, hash)
      })
      
      // Set all other nav links to inactive
      accountNavBtns.forEach(btn => {
        navBtnHandler(btn, hash)
      })
    });
    
    // Hash URL change event listeners, since hash IDs have underscore to prevent page jumping
    accountNavBtns.forEach(accountNavBtn => {
      navBtnChangeHash(accountNavBtn)
    })
  }

  // Function to handle switching active page
  const pageHandler = (page, hash) => {
    if (page.id === `${hash}-page`) {
      $(page).css({ 'display': 'flex' }) // sets correct page to display
    } else if (page.id === "overview-page" && hash === '') {
      $(page).css({ 'display': 'flex' }) // sets overview page to display as fallback
    } else if (page.id === "overview-page" && hash === 'smile-home') {
      $(page).css({ 'display': 'flex' }) // sets overview page to display as fallback
    } else {
      $(page).css({ 'display': 'none' }) // hides all other pages
    }
    window.scrollTo(0, 0);
  }

  // Function to handle switching active nav item
  const navBtnHandler = (btn, hash) => {
    if (btn.children[0].id.split("_")[0] === hash) {
      $(btn).addClass('nav-active') // Set this nav link to active
      $(btn).removeClass('nav-inactive')
    } else {
      $(btn).addClass('nav-inactive') // Set all other nav link to inactive
      $(btn).removeClass('nav-active')
    }
  }
  
  // Function to handle switching hash in URL based on button click
  const navBtnChangeHash = (btn) => {
    let navBtnID = btn.children[0].id.split("_")[0]
    btn.addEventListener('click', (e) => {
      window.location.hash = navBtnID; //set hash
    })
  }

  accountNavHandler()

  if (window.location.hash) {
    let hash = window.location.hash.slice(1); // hash to string (= "#orders")
    accountPages.forEach(page => {
      pageHandler(page, hash)
    })
    accountNavBtns.forEach(btn => {
      navBtnHandler(btn, hash)
    })
  }
    
  // Hash URL change event listeners to misc buttons
  let viewAllOrdersBtn = document.querySelectorAll(".view-orders-btn")[0]
  viewAllOrdersBtn.addEventListener('click', (e) => {
    window.location.hash = "#orders";
  })
  let viewAllAddressesBtn = document.querySelectorAll(".view-addresses-btn")[0]
  viewAllAddressesBtn.addEventListener('click', (e) => {
    window.location.hash = "#address-book";
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/account-page.js